import { Layout } from "../../layouts/v1";
import { MainView } from "../../views/coupang/root";
import { CollectedOrderDatasContextProvider } from "../../views/coupang/root/contexts/CollectedOrderDatasContext";
import { CoupangApiStoreInfoContextProvider } from "../../views/coupang/root/contexts/CoupangApiStoreInfoContext";
import { SelectedCollectedOrderDataContextProvider } from "../../views/coupang/root/contexts/SelectedCollectedOrderDataContext";
import { SelectedCoupangApiStoreInfosContextProvider } from "../../views/coupang/root/contexts/SelectedCoupangApiStoreInfosContext";

export function CoupangPage(props) {
    return (
        <>
            <CoupangApiStoreInfoContextProvider>
                <SelectedCoupangApiStoreInfosContextProvider>
                    <CollectedOrderDatasContextProvider>
                        <SelectedCollectedOrderDataContextProvider>
                            <Layout>
                                <MainView />
                            </Layout>
                        </SelectedCollectedOrderDataContextProvider>
                    </CollectedOrderDatasContextProvider>
                </SelectedCoupangApiStoreInfosContextProvider>
            </CoupangApiStoreInfoContextProvider>
        </>
    );
}